import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { User } from 'types/api/users.type';

import type { RootState } from '../store';

const usersAdapter = createEntityAdapter({
  selectId: (user: User) => user.id,
});

export const usersSlice = createSlice({
  name: 'users',
  initialState: usersAdapter.getInitialState(),
  reducers: {
    setUsers(state, action) {
      usersAdapter.setAll(state, action.payload);
    },
    removeUser(state, action) {
      usersAdapter.removeOne(state, action.payload);
    },
  },
});

export const getState = (rootState: RootState) => rootState.users;

export const usersSelector = usersAdapter.getSelectors((state: RootState) => state.users);

export const { setUsers, removeUser } = usersSlice.actions;
